class TableIconReplacer {
    constructor() {

        this.symbol1 = [];
        this.symbol2 = [];
        this.symbol3 = [];
        this.symbol4 = [];
        this.symbol5 = [];

        this.symbolArray1 = document.querySelectorAll('.ns-horizontal-right');
        this.symbolArray2 = document.querySelectorAll('.ns-horizontal-right');
        this.symbolArray3 = document.querySelectorAll('.ns-horizontal-right');
        this.symbolArray4 = document.querySelectorAll('.ns-horizontal-right');
        this.symbolArray5 = document.querySelectorAll('.ns-horizontal-right');

        this.symbolArray1.forEach(item => {
          if(item.innerText.trim() == 'icon-dev') {
            this.symbol1.push(item);
          }
        });

        this.symbolArray2.forEach(item => {
          if(item.innerText.trim() == 'icon-new') {
            this.symbol2.push(item);
          }
        });

        this.symbolArray3.forEach(item => {
          if(item.innerText.trim() == 'icon-pos') {
            this.symbol3.push(item);
          }
        });

        this.symbolArray4.forEach(item => {
          if(item.innerText.trim() == 'icon-neg') {
            this.symbol4.push(item);
          }
        });

        this.symbolArray5.forEach(item => {
          if(item.innerText.trim() == 'icon-non') {
            this.symbol5.push(item);
          }
        });


        if(this.symbol1.length > 0){
            this.changeSymbol(this.symbol1, "icon-dev.min.svg", "Entwicklung nicht bewertbar");
        }

        if(this.symbol2.length > 0){
            this.changeSymbol(this.symbol2, "icon-new.min.svg", "Neuer Indikator");
        }

        if(this.symbol3.length > 0){
            this.changeSymbol(this.symbol3, "icon-pos.min.svg", "Positive Entwicklung");
        }

        if(this.symbol4.length > 0){
            this.changeSymbol(this.symbol4, "icon-neg.min.svg", "Negative Entwicklung");
        }

        if(this.symbol5.length > 0){
          this.changeSymbol(this.symbol5, "icon-non.min.svg", "Keine Veränderung");
      }
    }

    changeSymbol(symbols, img, alt){
        symbols.forEach(symbol => {
            let th = symbol.closest('td') ? symbol.closest('td') : symbol.closest('th');
            let url = window.location.origin.includes('my.nswow') ? 'https://my.nswow.ch/hosting/strabag/geschaeftsbericht-2024/preview' : 'https://report.strabag.com/2024/ar';
            th.classList.add('ns-symbol-container');
            th.removeChild(th.firstElementChild);
            let symbolImage = document.createElement('img');
            symbolImage.setAttribute('src', url + '/svg/' + img);
            symbolImage.setAttribute('alt', alt);
            symbolImage.setAttribute('title', 'Icon, ' + alt);
            symbolImage.setAttribute('class', 'ns-symbol');
            th.append(symbolImage);
        });
    }

}

export default TableIconReplacer;
